import styled from 'styled-components';

export const Content = styled.div`
  padding-left: 90px;
  background: url('/images/exclamation.svg') no-repeat 0 0;
  background-size: 50px;
`;

export const Header = styled.div`
  font-size: 20px;
  font-weight: bold;
  margin: 0 0 10px;
`;

export const Info = styled.div`
  font-size: 15px;
  padding: 0 0 15px;
  margin: 0 0 15px;
  position: relative;
  &:after {
    content: '';
    position: absolute;
    bottom: 0;
    left: -110px;
    right: -20px;
    height: 1px;
    border-bottom: 1px solid ${(props) => (props.$invalid ? '#d33d34' : '#cccccc')};
  }
`;

export const GrayInfo = styled.div`
  margin: 10px 0;
  color: gray;
  font-size: 12px;
`;
